import { useEffect, RefObject } from 'react';

/**
 * Custom hook to automatically scroll to bottom when dependencies change
 * Uses requestAnimationFrame for better performance
 */
export function useScrollToBottom(
  messagesEndRef: RefObject<HTMLDivElement | null>,
  dependencies: unknown[]
) {
  useEffect(() => {
    // Use requestAnimationFrame for better performance
    const scroll = () => {
      requestAnimationFrame(() => {
        messagesEndRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
        });
      });
    };

    scroll();
  }, dependencies);
}
